export * from './levantamento-quantitativo-slice'